// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details-label[data-v-545b3bc4]{font-weight:700}.details-value[data-v-545b3bc4]{margin-left:10px}", ""]);
// Exports
module.exports = exports;
